import { render, staticRenderFns } from "./HeaderActionBackButton.vue?vue&type=template&id=1a9f0a28"
import script from "./HeaderActionBackButton.vue?vue&type=script&lang=js"
export * from "./HeaderActionBackButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a9f0a28')) {
      api.createRecord('1a9f0a28', component.options)
    } else {
      api.reload('1a9f0a28', component.options)
    }
    module.hot.accept("./HeaderActionBackButton.vue?vue&type=template&id=1a9f0a28", function () {
      api.rerender('1a9f0a28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/Buttons/HeaderActionBackButton.vue"
export default component.exports